import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '@/ducks/store';

import type { Agency } from '@/types/Agency';

export interface AgencyState {
  entry: Agency;
}

export const initialState: AgencyState = {
  entry: {
    name: '',
    fullName: '',
    public: false,
    insurancePrograms: [''],
    aipAutomaticPairing: false,
    settings: [],
    smsService: false,
    mailSender: '',
    bindingEnabled: false,
    uiClientName: '',
    docuSignBrandId: '',
    aipAutomaticFormUpload: false,
    informationalMessages: false
  }
};

export const agencySlice = createSlice({
  name: 'agency',
  initialState,
  reducers: {
    setAgency(state, action: PayloadAction<Agency>) {
      state.entry = { ...action.payload };
    }
  }
});

export const getAgencyName = (state: RootState) => state.agency.entry.name;
export const getAgencyFullName = (state: RootState) => state.agency.entry.fullName;
export const getAgency = (state: RootState) => state.agency.entry;
export const getAgencyInsurancePlans = (state: RootState) => state.agency.entry.insurancePrograms;
export const getAgencyAutomaticFormUpload = (state: RootState) =>
  state.agency.entry.aipAutomaticFormUpload;

export const { setAgency } = agencySlice.actions;
// eslint-disable-next-line import/no-default-export
export default agencySlice.reducer;
